import axios from "axios";

const API_GO = process.env.REACT_APP_API_GO;

export const getIOFormLookups = async (ids = "") => {
	const params = ids ? { ids } : {};
	const { data } = await axios.get(`${API_GO}/app/history/io/lookups`, { params });
	return data;
};

export const getIODetail = async (historyId) => {
	const { data } = await axios.get(`${API_GO}/app/history/io/${historyId}`);
	return data;
};

export const updateIO = async (historyId, io, listType = null, filters = null) => {
	const payload = { application: io };
	if (listType && filters) {
		payload.list_type = listType;
		payload.filters = filters;
	}
	const { data } = await axios.put(`${API_GO}/app/balance/io/${historyId}`, payload);
	return data;
};

export const getIOGroupData = async (outputCode, balanceId) => {
	const { data } = await axios.get(`${API_GO}/app/history/io/group`, {
		params: { output_code: outputCode, balance_id: balanceId },
	});
	return data;
};

export const returnIO = async ({ ioIds, action, filters = null }) => {
	const payload = { io_ids: ioIds, action };
	if (filters) {
		payload.filters = filters;
	}
	const { data } = await axios.post(`${API_GO}/app/balance/io/return`, payload);
	return data;
};

export const bulkUpdateIOOAs = async (ids, idsOAs, listType = null, filters = null) => {
	const payload = { ids, ids_oas: idsOAs };
	if (listType && filters) {
		payload.list_type = listType;
		payload.filters = filters;
	}
	const { data } = await axios.put(`${API_GO}/app/balance/io/bulk`, payload);
	return data;
};

export const deleteIO = async ({ selected, listType = null, filters = null }) => {
	const payload = { selected };
	if (listType && filters) {
		payload.list_type = listType;
		payload.filters = filters;
	}
	const { data } = await axios.post(`${API_GO}/app/balance/io/delete`, payload);
	return data;
};
